import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'js-cookie';

const EssaysDetails = () => {
  const [essayDetails, setEssayDetails] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [grade, setGrade] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchEssayDetails = async () => {
      try {
        const response = await axios.get(`https://backend.writerswright.com/api/v1/teacher/getTeacherEssay?Id=${Cookies.get('essayId')}`);
        setEssayDetails(response.data);
      } catch (error) {
        console.error('Error fetching essay details:', error);
      }
    };

    fetchEssayDetails();
  }, []);

  const handleProfileModalShow = () => setShowProfileModal(true);
  const handleProfileModalClose = () => setShowProfileModal(false);

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put('https://backend.writerswright.com/api/v1/teacher/markgrade', {
        essayId: Cookies.get('essayId'),
        grade: grade,
        feedback: feedback,
      });
      console.log('Grade marked successfully:', response.data);
      // Optionally, you can update local state or show a success message here
    } catch (error) {
      console.error('Error marking grade:', error);
      // Handle error scenario here
    }
    handleProfileModalClose();
  };

  if (!essayDetails) {
    return <div>Loading...</div>; // Placeholder for loading state
  }

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="title">Essay Details</h2>
        <button className="button-37" onClick={handleProfileModalShow}>
          Grade Essay
        </button>
      </div>
      <div
        style={{
          width: '100%',
          height: '100%',
          margin: '10px auto',
          borderRadius: '10px',
          boxShadow: ' rgba(0, 0, 0, 0.35) 0px 5px 15px',
        }}
      >
        <Row style={{ padding: '5% 10%' }}>
          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Essay Name</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essayDetails.Title}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Due Date</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essayDetails.deadline}</div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Student Name</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>
              {essayDetails.Name} {essayDetails.Surname}
            </div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: 'var(--primary)' }}>Essay Details</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essayDetails.details}</div>
          </Col>
        </Row>
      </div>

      <Modal show={showProfileModal} onHide={handleProfileModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Grade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleProfileSubmit}>
            <Form.Group controlId="formassigngrade">
              <Form.Label>Assign Grade</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Grade"
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formFeedback">
              <Form.Label>Feedback</Form.Label>
              <textarea
                className="form-control"
                id="feedback"
                name="feedback"
                rows="4"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                required
              />
            </Form.Group>
            <button className="button-37 mt-2" type="submit" style={{ marginRight: '5px', width: '100%' }}>
              Mark As Graded
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default EssaysDetails;
